import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import "swiper/css/navigation";
import 'swiper/css/pagination';
// import { Navigation } from "swiper";
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';

SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Slider({ slides }) {
    return (
        <Swiper className="mySwiper"
                 //navigation
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
               // autoHeight={true}
                speed={2000}
                 pagination={{ clickable: true }}>
            {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                    <div className="sliderGrid">
                        <div className="sliderImage">
                            <img src={slide.image} alt="" />
                        </div>
                        <div className="sliderContent">

                            {slide.brand && <img className="mb-4" src={slide.brand} alt={slide.title} />}
                            <h2 className="mb-2">{slide.title}</h2>
                            {slide.description && (
                            <p>{slide.description}</p>
                            )}
                            {slide.buttonText && (
                            <a className="primary-button mt-6 arrow-right" href={slide.buttonURL}>{slide.buttonText}</a>
                            )}
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}